import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const GetQuizzes = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  const [quizzes, setQuizzes] = useState([]);
  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(true);

  const searchParams = new URLSearchParams(location.search);
  const manager = searchParams.get("manager");

  useEffect(() => {
    const fetchQuizzes = async () => {
      try {
        const response = await axiosPrivate.post(
          "/admin/getquizzes",
          JSON.stringify({
            manager: manager,
          })
        );

        setSuccess(true);
        setQuizzes(response?.data?.quizzes);
      } catch (err) {
        if (err?.response?.status === 404) {
          setErrMsg("No quizzes found for this manager.");
        } else if (err?.response?.status === 401) {
          setErrMsg("Invalid or missing authorization token.");
        } else {
          setErrMsg("Failed to retrieve quizzes due to an internal error.");
        }
      } finally {
        setLoading(false);
      }
    };
    fetchQuizzes();
  }, [axiosPrivate, manager]);

  return (
    <div className="fade-in" style={{ maxWidth: "1200px", margin: "0 auto", padding: "2rem 1rem" }}>
      {/* Back Button */}
      <button
        className="btn-secondary"
        style={{ marginBottom: "1.5rem", padding: "0.5rem 1rem", fontSize: "0.875rem" }}
        onClick={() => navigate("/admin")}
      >
        ← Back to Dashboard
      </button>

      {/* Header */}
      <div style={{ marginBottom: "2rem" }}>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            marginBottom: "0.5rem",
            background: "linear-gradient(135deg, var(--primary-purple-light), var(--accent-cyan))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Manager Quizzes
        </h1>
        <p style={{ color: "var(--text-muted)", fontSize: "1.125rem" }}>
          Viewing quizzes for: <span style={{ color: "var(--text-primary)", fontWeight: "600" }}>{manager}</span>
        </p>
      </div>

      {errMsg && <p className="errmsg">{errMsg}</p>}

      {loading ? (
        <div style={{ textAlign: "center", padding: "4rem" }}>
          <div className="spin" style={{ fontSize: "2rem", marginBottom: "1rem" }}>⏳</div>
          <p style={{ color: "var(--text-secondary)" }}>Loading quizzes...</p>
        </div>
      ) : (
        <>
          {success && quizzes.length > 0 ? (
            <div style={{ overflowX: "auto", borderRadius: "16px", border: "1px solid var(--border)" }}>
              <table style={{ width: "100%", minWidth: "800px" }}>
                <thead>
                  <tr>
                    <th>Quiz ID</th>
                    <th>Quiz Name</th>
                    <th>Quiz Type</th>
                    <th>Participants</th>
                    <th style={{ textAlign: "right" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {quizzes.map((quiz) => (
                    <tr key={quiz.quizid}>
                      <td style={{ fontFamily: "monospace", fontSize: "0.875rem" }}>{quiz.quizid.substring(0, 8)}...</td>
                      <td style={{ fontWeight: "600", color: "var(--text-primary)" }}>{quiz.quizname}</td>
                      <td>
                        <span style={{
                          padding: "0.25rem 0.75rem",
                          borderRadius: "9999px",
                          fontSize: "0.875rem",
                          background: "rgba(124, 58, 237, 0.2)",
                          border: "1px solid var(--primary-purple)",
                          color: "var(--primary-purple-light)"
                        }}>
                          {quiz.quiztype}
                        </span>
                      </td>
                      <td>{quiz.numParticipants}</td>
                      <td style={{ textAlign: "right" }}>
                        <button
                          className="btn-primary"
                          style={{ fontSize: "0.875rem", padding: "0.5rem 1rem", minWidth: "auto" }}
                          onClick={() => {
                            navigate(
                              "/admin/quizdetails/?quizid=" +
                              quiz.quizid +
                              "&manager=" +
                              manager
                            );
                          }}
                        >
                          View Details
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            !errMsg && (
              <div className="card" style={{ textAlign: "center", padding: "3rem" }}>
                <p style={{ color: "var(--text-muted)" }}>No quizzes found for this manager.</p>
              </div>
            )
          )}
        </>
      )}
    </div>
  );
};

export default GetQuizzes;
